import cn from "classnames";
import type { CalendarTask } from "./types";
import { PRIORITY_COLOR_CLASS, PRIORITY_BG } from "./consts";

interface Props {
  task: CalendarTask;
  onClick: () => void;
}

export default function CalendarTaskItem({ task, onClick }: Props) {
  return (
    <button
      type="button"
      onClick={(e) => {
        e.stopPropagation();
        onClick();
      }}
      className={cn(
        "w-full text-left px-1.5 py-0.5 radius-2xs truncate text-label-2xs cursor-pointer hover:opacity-90 transition-opacity",
        PRIORITY_BG[task.priority],
        PRIORITY_COLOR_CLASS[task.priority],
      )}>
      #{task.id} {task.title}
    </button>
  );
}
